import { useEffect, useState } from 'react';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { Typography, Popover, FormControl } from '@material-ui/core';
import {} from './../handler/ShareStatusKnowledgeHandler';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Button } from '@material-ui/core';
import './ListItemTagField.css';
import {
    bulkActionHelpdeskTaskIdAtom,
    bulkActionKnowledgeTaskIdAtom
} from '@/state/atom/ticketKnowledgeAtom';
import { cloneDeep } from 'lodash';
import {
    handleBulkUpdateTicketAPI,
    handleMsgPendingWhenBulkActionInProcessing
} from '../handler/ListTicketKnowledgeHandler';
import { useSnackbar } from 'notistack';
import OverFlowTooltipCheckBox from '@/component/common/OverFlowTooltipCheckBox';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';
import trI18n from '@/common/utils/trI18n';
import { tr, trTag } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

function ListItemOfPrivateBookmark(props) {
    // Subscribe to translation updates so displayed bookmark names re-render on language change
    useTranslationSubscription();
    const { setIsShowEditTagField, setIsShowDialogNotiLimit, selectedTagField } = {...props};
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const userDetail = useRecoilValue(userAtom);

    const [openShareStatusPopover, setOpenShareStatusPopover] = useState('');
    const idPopoverShareStatus = openShareStatusPopover ? 'simple-popover' : undefined;
    const [shareStatusPopover, setShareStatusPopover] = useState(false);
    const [listItem, setListItem] = useState([]);
    const setKnowledgeTaskId = useSetRecoilState(bulkActionKnowledgeTaskIdAtom);
    const setHelpDeskTaskId = useSetRecoilState(bulkActionHelpdeskTaskIdAtom);
    const { enqueueSnackbar } = useSnackbar();
    const [isDisable, setIsDisable] = useState(false);
    const [isOnChange, setIsOnChange] = useState(false);

    useEffect(() => {
        let selectedFieldId = selectedTagField?.id;
        let drillDataOfField = props.drillDownData?.filter(drillDownItem => {
            return selectedFieldId.includes(drillDownItem?.id);
        });

        let listItemOfTagField = [];
        let listItemSelectedOfField = [];
        if (!Utils.isEmptyArray(drillDataOfField)) {
            for(let field of drillDataOfField) {
                const childField = field.child || [];
                listItemSelectedOfField.push(...childField)
            }
        }

        props.listTagItem?.forEach(itemDetail => {
            let itemInfo = {
                id: itemDetail.id,
                name: itemDetail.name,
                shareRange: itemDetail.shareRange,
                status: 'uncheck'
            };

            let dataDrillDownOfItem = listItemSelectedOfField?.find(
                item => item.id === itemDetail.id
            );
            if (dataDrillDownOfItem) {
                itemInfo.indeterminate =
                    dataDrillDownOfItem.total >= props.totalTickets ? false : true;
                itemInfo.status =
                    dataDrillDownOfItem.total >= props.totalTickets
                        ? 'checked'
                        : 'indeterminate';
                itemInfo.total = dataDrillDownOfItem.total;
            }
            listItemOfTagField.push(itemInfo);
        });

        setListItem(listItemOfTagField);
    }, [props.drillDownData, props.listTagItem, props.totalTickets, selectedTagField]);

    useEffect(() => {
        setIsOnChange(false);
    }, [selectedTagField]);

    const handleOnChange = item => {
        let itemClone = cloneDeep(item);
        switch (item.status) {
            case 'checked':
                itemClone.status = 'uncheck';
                break;
            case 'indeterminate':
                itemClone.status = 'checked';
                itemClone.indeterminate = false;
                break;
            case 'uncheck':
                itemClone.status = 'checked';
                break;

            default:
                break;
        }
        let indexOfActionItem = listItem?.findIndex(itemDetail => itemDetail.id === item.id);
        if (indexOfActionItem >= 0) {
            setIsOnChange(true);
            let listItemClone = cloneDeep(listItem);
            listItemClone[indexOfActionItem] = itemClone;
            setListItem([...listItemClone]);
        }
    };

    const handleSubmitEditTagFields = async () => {
        if (props.totalTickets > Constant.LIMIT_TICKET_UPDATE_MULTI) {
            setIsShowEditTagField(false);
            setIsShowDialogNotiLimit(true);
            return;
        }

        let listItemObject = listItem
            ?.filter(item => !item.indeterminate)
            .map(item => {
                let itemObject = { itemId: item.id, shareRange: item.shareRange };
                if (item.status === 'checked') {
                    itemObject.isCheckAll = true;
                }
                if (item.status === 'uncheck') {
                    itemObject.uncheckAll = true;
                }

                return itemObject;
            });

        let params = {
            searchCondition: JSON.stringify({
                listItem: listItemObject,
                tagFieldId: props?.selectedTagField?.id,
                ...props.currentSearchParams,
                userAffiliationOrganization: userDetail?.affiliationOrganization || props?.currentSearchParams?.corporationId,
                projectInuse: projectInuseDetail?.id,
                formId: props.selectedFormId,
                userId: userDetail?.id,
                corporationInuse: userDetail?.affiliationOrganization
            }),
            action:
                {...props}?.action === Constant.BULK_ACTION.HELPDESK_EDIT_TAG_FIELD
                    ? Constant.BULK_ACTION.HELPDESK_BOOKMARK_TICKET
                    : Constant.BULK_ACTION.KNOWLEDGE_BOOKMARK_TICKET
        };

        setIsShowEditTagField(false);
        document.body.style.cursor = 'wait';
        let setTaskId =
            {...props}?.action === Constant.BULK_ACTION.HELPDESK_EDIT_TAG_FIELD
                ? setHelpDeskTaskId
                : setKnowledgeTaskId;
        handleBulkUpdateTicketAPI(
            { params: params },
            null, //setIsOpenDialogConfirm
            setTaskId,
            false,
            enqueueSnackbar,
            props.setIsOpenAlertDialog
        );

        props.setMsgInProcessingIcon(handleMsgPendingWhenBulkActionInProcessing(props?.action));
    };

    const renderListBasicView = () => {
        let privateBookmarkList = listItem.filter(bookmark => bookmark?.shareRange === userDetail.id);
        let sharedBookmarkList = listItem.filter(bookmark => bookmark?.shareRange !== userDetail.id);

        return (
            <FormControl
                component="fieldset"
                className="list-item-of-tag"
                id={`form-control-share-status-all`}
            >   
                {!Utils.isEmptyArray(privateBookmarkList) && <span className='bookmark-group-label'>{trI18n('PRIVATE_BOOKMARK_TAG')}</span>}
                {privateBookmarkList?.map(item => {
                    const displayName = trTag(item.name);
                    return (
                        <OverFlowTooltipCheckBox
                            value={displayName}
                            name={displayName}
                            status={item.status}
                            indeterminate={item.indeterminate}
                            handleOnChange={handleOnChange}
                            item={item}
                            id={item.id}
                        />
                    );
                })}

                {!Utils.isEmptyArray(sharedBookmarkList) && <span className='bookmark-group-label'>{trI18n('SHARE_BOOKMARK_TAG')}</span>}
                {sharedBookmarkList?.map(item => {
                    const displayName = trTag(item.name);
                    return (
                        <OverFlowTooltipCheckBox
                            value={displayName}
                            name={displayName}
                            status={item.status}
                            indeterminate={item.indeterminate}
                            handleOnChange={handleOnChange}
                            item={item}
                            id={item.id}
                        />
                    );
                })}
            </FormControl>
        );
    };

    const handleClickShowShareStatus = event => {
        setOpenShareStatusPopover(true);
        props.setIsShowListItemOfTagField(true);
        setShareStatusPopover(event.currentTarget);
    };

    const handleClosePopoverShareStatus = async () => {
        setShareStatusPopover(null);
        setOpenShareStatusPopover(false);
        props.setIsShowListItemOfTagField(false);
    };

    return (
        <div className="">
            <Typography
                className=""
                aria-describedby={idPopoverShareStatus}
                variant="contained"
                onClick={e => {
                    handleClickShowShareStatus(e);
                }}
            >
                {' '}
                <img src="/assets/image/edit-setting-public-url.svg" alt="icon-edit-range" />
            </Typography>
            <Popover
                className="share-status-popover"
                id={idPopoverShareStatus}
                key={`popover-share-status-all`}
                open={openShareStatusPopover}
                anchorEl={shareStatusPopover}
                onClose={e => handleClosePopoverShareStatus()}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                PaperProps={{
                    style: {
                        marginTop: '12px',
                        marginLeft: '7px',
                        borderRadius: '8px',
                        minWidth: '300px'
                    }
                }}
            >
                <div>
                    <div
                        className="listView knowledge-share-public-status-list"
                        id={`share_status_id_all_bm`}
                    >
                        <div className="list-permission-status list-item-selected-tag-field">
                            {renderListBasicView()}
                        </div>
                        <div className="share-status-popover-additional">
                            <Button
                                className="btn-send btn-primary btn-hg32"
                                variant="contained"
                                color="primary"
                                onClick={e => handleSubmitEditTagFields()}
                                disabled={isDisable || !isOnChange}
                            >
                                {tr('適用')}
                            </Button>
                        </div>
                    </div>
                </div>
            </Popover>
        </div>
    );
}

export default ListItemOfPrivateBookmark;
